import React from "react";
import useEmblaCarousel from "embla-carousel-react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const SLIDES = [
  { size: "10", src: "/images/size-10.jpg?v=2", alt: "Pile Glide Pro 10 inch marine pile hoop" },
  { size: "12", src: "/images/size-12.jpg?v=2", alt: "Pile Glide Pro 12 inch marine pile hoop" },
  { size: "14", src: "/images/size-14.jpg?v=2", alt: "Pile Glide Pro 14 inch marine pile hoop" },
];

export default function SizeCarousel({ testIdPrefix = "size-carousel" }) {
  const [emblaRef, embla] = useEmblaCarousel({ loop: true, startIndex: 0 });
  const [selected, setSelected] = React.useState(0);

  React.useEffect(() => {
    if (!embla) return;
    const onSelect = () => setSelected(embla.selectedScrollSnap());
    embla.on("select", onSelect);
    onSelect();
    return () => embla.off("select", onSelect);
  }, [embla]);

  const scrollPrev = () => embla?.scrollPrev();
  const scrollNext = () => embla?.scrollNext();
  const scrollTo = (i) => embla?.scrollTo(i);

  return (
    <div data-testid={testIdPrefix}>
      <div className="flex items-center gap-3 md:gap-4">
        <button
          type="button"
          onClick={scrollPrev}
          aria-label="Previous size"
          data-testid={`${testIdPrefix}-prev`}
          className="shrink-0 flex items-center justify-center w-11 h-11 md:w-12 md:h-12 bg-white border-2 border-[#091526] hard-shadow hover:bg-[#1E5BB8] hover:text-white transition-colors"
        >
          <ChevronLeft size={22} strokeWidth={3} />
        </button>

        <div
          className="flex-1 min-w-0 overflow-hidden border-2 border-[#091526] bg-[#F4F4F5]"
          ref={emblaRef}
        >
          <div className="flex">
            {SLIDES.map((s) => (
              <div
                key={s.size}
                className="relative shrink-0 grow-0 basis-full"
                data-testid={`${testIdPrefix}-slide-${s.size}`}
              >
                <img
                  src={s.src}
                  alt={s.alt}
                  className="w-full aspect-[3/4] object-cover block"
                />
              </div>
            ))}
          </div>
        </div>

        <button
          type="button"
          onClick={scrollNext}
          aria-label="Next size"
          data-testid={`${testIdPrefix}-next`}
          className="shrink-0 flex items-center justify-center w-11 h-11 md:w-12 md:h-12 bg-white border-2 border-[#091526] hard-shadow hover:bg-[#1E5BB8] hover:text-white transition-colors"
        >
          <ChevronRight size={22} strokeWidth={3} />
        </button>
      </div>

      <div className="mt-4 flex items-center justify-center gap-3">
        {SLIDES.map((s, i) => (
          <button
            key={s.size}
            type="button"
            onClick={() => scrollTo(i)}
            aria-label={`Show ${s.size} inch`}
            data-testid={`${testIdPrefix}-dot-${s.size}`}
            className={`font-mono text-xs uppercase tracking-[0.2em] font-bold px-3 py-1.5 border-2 border-[#091526] transition-colors ${
              selected === i
                ? "bg-[#1E5BB8] text-white"
                : "bg-white text-[#091526] hover:bg-[#F4F4F5]"
            }`}
          >
            {s.size}″
          </button>
        ))}
      </div>
    </div>
  );
}
